import {Action} from 'redux-actions';
import {
    PagingParams,
    Sort,
} from '@pluto/table';
import {
    QCFiltersParams,
    Assignee,
} from '../../QCWorkflow/QCManager/QCManagerTypes';

export enum UserStatusEnum {
    Active = 'ACTIVE',
    Deactivated = 'DEACTIVATED',
    Pending = 'PENDING',
}

export interface UserOption {
    id: number;
    email: string;
    name: string;
    roles: string[];
    status: string | UserStatusEnum;
    updatedAt: string;
    createdAt: string;
    lastLoginAt: string | null;
    deletedAt: string | null;
}

export interface UsersPayload {
    total: number;
    rows: UserOption[];
}

export type UserPayload = UserOption;
export type UserListAction = Action<UsersPayload>;
export type UserAction = Action<UserPayload>;

export interface User extends UserOption {
    rolesStr: string;
}

export enum UserRolesEnum {
    Default = 'default',
    Administrator = 'admin',
    ContentOps = 'contentOpsCoordinator',
    QCOperator = 'qcOperator',
}

export interface UserListFilterParams extends Sort, PagingParams {
    name?: string;
    status?: UserStatusEnum[];
    roles?: UserRolesEnum[];
}

export interface UserEditParams {
    id: string;
    body: string[];
}

export interface UserAddParams {
    email: string;
    body: string[];
}

export type UserPromise = Promise<UsersPayload>;

export type SetUsersAction = (params?: UserListFilterParams) => void;
export type UserValue = Assignee | null | undefined;
export type OnUserChange = (value: UserValue) => void;

export interface UsersState {
    total: number;
    rows: UserOption[];
    isLoading: boolean;
}

export interface UserData {
    total: number;
    rows: UserOption[];
}

export type UserState = UserOption;

export interface UsersProps {
    getOptionSelected: (option: string, value: string) => boolean;
    getOptionLabel: (value: string) => string;
    opts: UserOption[];
    value?: UserValue;
    onChange: OnUserChange;
    assignedUser: UserValue;
}

export interface UsersContainerProps {
    setUsers: (params: QCFiltersParams) => void;
    rows: UserOption[];
    value?: UserValue;
    isLoading: boolean;
    onChange: OnUserChange;
    assignedUser: UserValue;
}

export interface HandleChangeProps {
    rows: UserOption[];
    onChange: OnUserChange;
}

export interface renderTextInputProps {
    InputLabelProps: {};
    InputProps: {};
    disabled: boolean;
    fullWidth: boolean;
    inputProps: {};
    size?: 'small' | 'medium'
}
